import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import CredoraIcon from "./CredoraIcon";
import { CREDORA_MODAL_CONTAINER } from "./credoraModalUtils";

const TONE_META = {
  primary: { icon: "check", confirmColor: "primary" },
  danger: { icon: "warning", confirmColor: "danger" },
  warning: { icon: "clock", confirmColor: "warning" },
  success: { icon: "check", confirmColor: "success" },
};

/**
 * Presentational confirmation dialog. Prefer useConfirmDialog() for app-wide prompts.
 */
const CredoraConfirmDialog = ({
  isOpen,
  toggle,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  tone = "primary",
  loading = false,
  error = "",
  onConfirm,
}) => {
  const meta = TONE_META[tone] || TONE_META.primary;

  return (
    <Modal
      isOpen={isOpen}
      toggle={loading ? undefined : toggle}
      centered
      className="credora-confirm-dialog"
      container={CREDORA_MODAL_CONTAINER}
    >
      <ModalHeader toggle={loading ? undefined : toggle}>{title}</ModalHeader>
      <ModalBody>
        <div className="credora-confirm-dialog__body">
          <span className={`credora-confirm-dialog__icon credora-confirm-dialog__icon--${tone}`}>
            <CredoraIcon name={meta.icon} size={22} iconClassName="svg-stroke" />
          </span>
          {message && <p className="credora-confirm-dialog__message mb-0">{message}</p>}
        </div>
        {error && <p className="credora-confirm-dialog__error mb-0 mt-3">{error}</p>}
      </ModalBody>
      <ModalFooter>
        <Button color="light" className="border" onClick={toggle} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button color={meta.confirmColor} onClick={onConfirm} disabled={loading}>
          {loading ? <Spinner size="sm" /> : confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CredoraConfirmDialog;
